module.exports = __webpack_public_path__ + "img/about1 (4).11fa57c2.png";